import React from 'react';
import {connect} from 'react-redux';
import {hashHistory} from 'react-router';

import api from '../utility/api';
import List from '../screens/list/';
import appConstants from '../utility/app-constants';
import {asyncStart, asyncEnd, showFeedback} from '../actions/application';
import { getListUIPreference, setListUIPreference } from '../utility/local-storage';

class TipsList extends React.Component {

  constructor() {
    super(...arguments);
    const {defaultSort, pageSize} = this.loadUIPreferences();
    this.state = {
      tips: [],
      sortPref: defaultSort,
      pageSize
    };
  }

  componentDidMount() {
    this.getTipsList();
  }

  loadUIPreferences() {
    const listPreference = getListUIPreference(appConstants.LIST.TIPS);
    const defaultSort = listPreference && listPreference.sortPref? listPreference.sortPref :
      [
        {
          id: 'created_at',
          desc: true
        }
      ];
    const pageSize = listPreference && listPreference.sortPref ? listPreference.pageSize : 20;

    return {defaultSort, pageSize};
  }

  getTipsList(){
    this.props.dispatch(asyncStart());
    api.getTips()
      .then(resp => {
        this.props.dispatch(asyncEnd());
        this.setState({tips: resp});
      })
      .catch(error => {
        this.props.dispatch(asyncEnd());
        this.props.dispatch(showFeedback({message: error.message}));
      });
  }

  onSortedChange(newSorted){
    let currentPreference = getListUIPreference(appConstants.LIST.TIPS);
    currentPreference = currentPreference || {};
    currentPreference.sortPref = newSorted;
    setListUIPreference(appConstants.LIST.TIPS, currentPreference);
  }

  onPageSizeChange(pageIndex) {
    let currentPreference = getListUIPreference(appConstants.LIST.TIPS);
    currentPreference = currentPreference || {};
    currentPreference.pageSize = pageIndex;
    setListUIPreference(appConstants.LIST.TIPS, currentPreference);
  }

  render() {
    const columns = [
      {
        Header: 'Id',
        accessor: 'id',
        show: false
      },
      {
        id: 'tipTitle',
        Header: 'Title',
        accessor: d => d.tip_title
      },
      {
        id: 'tipUrl',
        Header: 'Url',
        accessor: d => d.url
      },
      {
        id: 'adminName',
        Header: 'Author',
        accessor: d => d.author.name
      },
      {
        id: 'created_at',
        Header: 'Created',
        accessor: d => d.created_at
      }


    ];

    const {tips, pageSize, sortPref} = this.state;
    const {isLoading} = this.props.application;

    let reactTableProps = {
      data: tips,
      columns,
      isLoading,
      defaultSorted: sortPref,
      defaultPageSize: pageSize,
      onSortedChange: this.onSortedChange.bind(this),
      onPageSizeChange: this.onPageSizeChange.bind(this),
      noDataText: 'No tips found',
      getTdProps: (state, rowInfo) => {
        return {
          onClick: e => {
            if (rowInfo)
              hashHistory.push('tips/' + rowInfo.row.id)
          }
        }
      }
    };

    return (
      <List
        title="Tips"
        addNewBtnLabel="Add New Tip"
        listId={appConstants.LIST.TIPS}
        reactTableProps={reactTableProps}
        onCreateNew={() => hashHistory.push('create-tip')}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user
  }
}

export default connect(mapStateToProps, null)(TipsList);


// WEBPACK FOOTER //
// ./src/containers/tips.js